export const formatTimePlayer = (cursorTime: number) => {
  const minutes = Math.floor(cursorTime / 60);
  const seconds = Math.floor(cursorTime % 60);

  return `${minutes.toString().padStart(2, '0')}:${seconds
    .toString()
    .padStart(2, '0')}`;
};
